import styled from 'styled-components';
import { isMobile } from 'utils';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NftDetailsPlainWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NftDetailsPlainSectionTitle = styled.h4`
  color: var(--v3-text-color);
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
`;

export const SegmentedWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 32px 0 40px;
  .ant-segmented-item-label {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.16px;
    color: var(--v3-text-color-secondary);
  }
  &&& {
    .ant-segmented {
      border-radius: 12px;
      padding: 4px;
      width: 100%;
    }
    .ant-segmented-item-selected {
      border-radius: 12px;
      box-shadow: 0 2px 2px rgba(36, 88, 255, 0.04);
      .ant-segmented-item-label {
        font-weight: 500;
        color: var(--v3-text-color);
      }
    }
    .ant-segmented-item {
      padding: 12px ${isMobile() ? 12 : 24}px;
    }
  }
`;
